export enum TipoNaturezaFiscal {
  CONTRIBUINTE = 'CONTRIBUINTE',
  NAO_CONTRIBUINTE = 'NAO_CONTRIBUINTE',
}
